import {ListHelpService} from './list-help.service';

export const ListHelpInjectables: Array<any> = [
  {
    provide: ListHelpService,
    useClass: ListHelpService,
  },
];
